/**
 * Product Card Multi-Image Loop - V8 (Mobile-Optimized Automatic Gallery)
 */
(function () {
    function initHoverSlides() {
        const cards = document.querySelectorAll('.product-card-item');
        const isMobile = window.matchMedia("(max-width: 991px)").matches;

        cards.forEach(card => {
            const images = card.querySelectorAll('.slideshow-img');
            if (images.length <= 1) return;

            // Ensure baseline visibility
            images.forEach((img, idx) => {
                img.style.position = idx === 0 ? 'relative' : 'absolute';
                img.style.top = '0';
                img.style.left = '0';
                img.style.width = '100%';
                img.style.height = '100%';
            });

            let currentIndex = 0;
            let slideshowInterval = null;

            const resetImages = () => {
                images.forEach((img, idx) => {
                    img.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
                    img.style.transform = idx === 0 ? 'translateX(0)' : 'translateX(100%)';
                    img.style.zIndex = idx === 0 ? '5' : '1';
                    img.style.opacity = '1';
                });
                currentIndex = 0;
            };

            const cycleImage = () => {
                const outgoingIndex = currentIndex;
                currentIndex = (currentIndex + 1) % images.length;
                const incomingIndex = currentIndex;

                // Playful Horizontal Slide (Used for both Desktop & Mobile)
                images[incomingIndex].style.transition = 'none';
                images[incomingIndex].style.transform = 'translateX(100%)';
                images[incomingIndex].style.opacity = '1';
                images[incomingIndex].style.zIndex = '10';
                images[outgoingIndex].style.zIndex = '5';

                void images[incomingIndex].offsetWidth;

                images[outgoingIndex].style.transition = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
                images[outgoingIndex].style.transform = 'translateX(-100%)';

                images[incomingIndex].style.transition = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
                images[incomingIndex].style.transform = 'translateX(0)';
            };

            // Event Listeners Reset
            card.removeEventListener('mouseenter', card._slideEnter);
            card.removeEventListener('mouseleave', card._slideLeave);
            if (card._mobileObserver) card._mobileObserver.disconnect();
            if (card._mobileInterval) clearInterval(card._mobileInterval);
            if (card._mobileTimeout) clearTimeout(card._mobileTimeout);

            if (isMobile) {
                resetImages();

                const observerOptions = {
                    root: null,
                    rootMargin: '50px',
                    threshold: 0.3
                };

                card._mobileObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // Fast, playful start
                            const initialDelay = 800 + (Math.random() * 400); // 0.8s - 1.2s
                            card._mobileTimeout = setTimeout(() => {
                                cycleImage(); // Trigger first slide quickly instead of waiting a full cycle
                                if (card._mobileInterval) clearInterval(card._mobileInterval);
                                card._mobileInterval = setInterval(cycleImage, 2500); // 2.5s snappy mobile interval
                            }, initialDelay);
                        } else {
                            if (card._mobileInterval) clearInterval(card._mobileInterval);
                            if (card._mobileTimeout) clearTimeout(card._mobileTimeout);
                            resetImages();
                        }
                    });
                }, observerOptions);

                card._mobileObserver.observe(card);

            } else {
                resetImages();

                card._slideEnter = () => {
                    if (slideshowInterval) clearInterval(slideshowInterval);
                    cycleImage();
                    slideshowInterval = setInterval(cycleImage, 1500);
                };

                card._slideLeave = () => {
                    if (slideshowInterval) clearInterval(slideshowInterval);
                    slideshowInterval = null;
                    resetImages();
                };

                card.addEventListener('mouseenter', card._slideEnter);
                card.addEventListener('mouseleave', card._slideLeave);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHoverSlides);
    } else {
        initHoverSlides();
    }

    // Support Shopify Theme Editor
    document.addEventListener('shopify:section:load', () => {
        setTimeout(initHoverSlides, 500);
    });
})();
